import * as React from 'react';

import * as style from './SearchModalEmpty.css';

export interface ISearchModalEmptyProps {
  color: string | null;
  text: string | null;
}

export const SearchModalEmpty: React.FC<ISearchModalEmptyProps> = props => {
  const { color, text } = props;

  if (!color || !text) {
    return null;
  }

  return (
    <div className={style['container']} style={{ color }}>
      {text}
    </div>
  );
};
